import { get } from "../../api";
import { authHeader } from "../../utils";

const getCardDetailsByCardNum = binNumber =>
  get("cardBin", { ...authHeader() }, binNumber);

export { getCardDetailsByCardNum };
